import { FacilityBonus } from './form';
import { ObjectPromotionEntity } from '../../../../generated/graphql';
import { errorToast, successToast } from '../../../../utils/helpers/notify';
import { errorHandler } from '../../../../utils/helpers/errorHandler';
import { usePromotionStore } from '../../../facilityGroup/useBonusProgramStore';
import Modal from 'ui/modal';
import { useResetToDefaultObjectPromotionMutation } from 'pages/facility/api/mutations/generated/ResetToDefaultObjectPromotion';
import { useDeleteObjectPromotionMutation } from 'pages/facilityGroup/api/mutations/generated/DeleteObjectPromotion';

type Props = {
  show: boolean;
  setShow: React.Dispatch<React.SetStateAction<boolean>>;
  promotion: FacilityBonus | ObjectPromotionEntity;
  type: 'reset' | 'delete';
};

const DefaultPromotionPopup = ({ show, setShow, promotion, type }: Props) => {
  const [resetToDefaultPromotionSettings] = useResetToDefaultObjectPromotionMutation();
  const [deletePromotion] = useDeleteObjectPromotionMutation();
  const changeBonuses = usePromotionStore(state => state.changePromotions);
  const setPromotions = usePromotionStore(state => state.setPromotions);
  const promotions = usePromotionStore(state => state.promotions);
  const showHandler = () => {
    setShow(value => !value);
  };
  const resetHandler = () => {
    resetToDefaultPromotionSettings({ variables: { input: { objectPromotionId: promotion.id } } })
      .then(response => {
        const res = response.data?.resetToDefaultObjectPromotion;
        if (!res) return;
        changeBonuses(promotion.id, {
          ...res,
          parent: res.parent
            ? {
                id: res.parent.id,
                name: res.parent.name,
                status: res.parent.status,
              }
            : null,
        });
        successToast('Акция сброшена на параметры по умолчанию');
      })
      .catch(err => {
        errorToast(errorHandler(err));
      })
      .finally(showHandler);
  };
  const deleteHandler = () => {
    deletePromotion({ variables: { input: { objectPromotionId: promotion.id } } })
      .then(response => {
        if (response.data?.deleteObjectPromotion) {
          setPromotions(promotions.filter((p: any) => p.id !== promotion.id));
          successToast('Бонусная программа удалена');
        }
      })
      .catch(err => {
        errorToast(errorHandler(err));
      })
      .finally(showHandler);
  };
  return (
    <Modal
      type={type === 'delete' ? 'delete' : undefined}
      open={show}
      title={type === 'delete' ? 'Удалить бонусную программу?' : 'Параметры по умолчанию?'}
      okText={type === 'delete' ? 'Удалить' : 'По умолчанию'}
      cancelText="Отменить"
      onCancel={showHandler}
      onOk={type === 'delete' ? deleteHandler : resetHandler}
    >
      {type === 'delete'
        ? 'Вы уверены, что хотите удалить бонусную программу?'
        : 'Вы уверены, что хотите вернуть параметры бонус. программы по умолчанию?'}
    </Modal>
  );
};

export default DefaultPromotionPopup;
